import {twJoin} from 'tailwind-merge'

import {onButtonKeyEvent, twMerge} from '@sdox/utils'

import {ExpandIndicator} from './ExpandIndicator'
import {Counter} from './Counter'
import {Media} from '../Media'

import type {ClassNameValue} from 'tailwind-merge'

export interface GalleryItemProps {
  src: string
  placeholderSrc?: string
  alt?: string
  index: number
  onClick: () => void
  buttonText?: string
  imagesLength: number
  counterClassName?: string
  expandIndicatorClassName?: string
  className?: ClassNameValue
}

export const GalleryItem = ({
  src,
  placeholderSrc,
  alt,
  index,
  imagesLength = 1,
  counterClassName,
  expandIndicatorClassName,
  onClick,
  className,
}: GalleryItemProps) => {
  const label = `gallery item ${index + 1}`

  return (
    <div
      role={'button'}
      tabIndex={0}
      aria-label={alt ?? label}
      className={twMerge(
        'group relative cursor-pointer',
        className,
      )}
      onClick={onClick}
      onKeyDown={onButtonKeyEvent(onClick)}
    >
      <Counter className={counterClassName}>
        {imagesLength - index}
      </Counter>
      <ExpandIndicator className={expandIndicatorClassName} />
      <Media
        src={src}
        placeholderSrc={placeholderSrc}
        alt={alt ?? label}
        aspectRatio={'16/10'}
        scrim={true}
        className={twJoin(
          'group-focus-visible:outline group-focus-visible:outline-4',
          'group-focus-visible:-outline-offset-2 group-focus-visible:outline-blue-500',
        )}
      />
    </div>
  )
}
